import { render, staticRenderFns } from "./MoviesTable.vue?vue&type=template&id=e2e7d586&"
import script from "./MoviesTable.vue?vue&type=script&lang=js&"
export * from "./MoviesTable.vue?vue&type=script&lang=js&"
import style0 from "./MoviesTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports